import type { ButtonConfig } from '../declare'
import * as Sider from './sider'
import { $consts } from 'src/plugins'

/**
 * 树表单层级树弹框类型按钮
 * @param props 
 * @returns 
 */
const SiderButton = (props: { config: ButtonConfig }) => {
  const { BTN_TYPE } = props.config
  switch (BTN_TYPE) {
    // 新增同级按钮
    case $consts['TABLE/BTN_TYPE_TREE_SAMELEVEL_ADD']:
      return <Sider.AddBtnSameLevel config={props.config} />
    // 自定义表单按钮
    case $consts['TABLE/BTN_TYPE_CUSTOM_PAGE']:
      return <Sider.FormModalBtn config={props.config} />
    // 新增下级按钮
    case $consts['TABLE/BTN_TYPE_ADD']:
      return <Sider.AddBtnDiffLevel config={props.config} />
    // 删除按钮
    case $consts['TABLE/BTN_TYPE_DELETE']:
      return <Sider.DeleteConfirmBtn config={props.config} />
    // 编辑表单按钮
    case $consts['TABLE/BTN_TYPE_EDIT_PAGE']:
      return <Sider.EditModalBtn config={props.config} />
    // 查看按钮
    case $consts['TABLE/BTN_TYPE_VIEW']:
      return <Sider.ViewModalBtn config={props.config} />
    default:
      return <div />
  }
}

export default SiderButton
